import * as CONS from '../../constants/urls'
import http from './httpService'

const API_ENDPOINT = `${CONS.API_ENDPOINT_EBM}/Scraps`

export function buscarTodosPorScraps(esScraps) {
  return http.get(`${API_ENDPOINT}/BuscarTodosPorScraps/${esScraps}`, {
    meta: {
      toastMessage: 'Ocurrió un error al obtener las categorías.',
      tipoError: 'categoriaScrap'
    }
  })
}
